module.exports = __webpack_public_path__ + "img/InterfaceIcon2.da7ece23.png";